function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M46.1927 11.1037L38.0356 2.93943C37.9525 2.85657 37.8539 2.79089 37.7455 2.74616C37.637 2.70142 37.5208 2.6785 37.4035 2.67871H18.0481C17.3142 2.67919 16.6104 2.97095 16.0915 3.48992C15.5725 4.00889 15.2807 4.71263 15.2802 5.44657V6.35371H14.3749C13.6413 6.35418 12.9378 6.6457 12.4189 7.16429C11.8999 7.68288 11.608 8.38616 11.607 9.11978V13.718C9.06594 14.3185 6.80196 15.7592 5.1818 17.8068C3.56164 19.8545 2.68018 22.3891 2.68018 25.0001C2.68018 27.6112 3.56164 30.1458 5.1818 32.1935C6.80196 34.2411 9.06594 35.6818 11.607 36.2823V41.8091C11.6089 43.2702 12.1901 44.6709 13.2231 45.7043C14.2561 46.7376 15.6566 47.3192 17.1177 47.3216H40.0124C40.7463 47.3211 41.4501 47.0293 41.969 46.5104C42.488 45.9914 42.7798 45.2877 42.7802 44.5537V43.6466H43.6856C44.4194 43.6461 45.123 43.3546 45.6423 42.8361C46.1615 42.3176 46.4538 41.6143 46.4552 40.8805V11.7341C46.4547 11.4975 46.3603 11.2708 46.1927 11.1037ZM38.2892 5.72693L43.4052 10.8412H38.2892V5.72693ZM13.3927 9.11978C13.3937 8.85976 13.4975 8.61068 13.6816 8.42698C13.8656 8.24328 14.1149 8.1399 14.3749 8.13943H15.2802V13.443C14.9517 13.4162 14.6213 13.393 14.2856 13.393C13.9838 13.393 13.6892 13.4162 13.3927 13.4376V9.11978ZM4.46417 25.0001C4.46417 23.0576 5.04019 21.1588 6.11938 19.5436C7.19857 17.9285 8.73247 16.6697 10.5271 15.9263C12.3217 15.183 14.2965 14.9885 16.2017 15.3674C18.1068 15.7464 19.8568 16.6818 21.2304 18.0553C22.604 19.4289 23.5394 21.1789 23.9183 23.0841C24.2973 24.9892 24.1028 26.964 23.3594 28.7586C22.6161 30.5533 21.3572 32.0872 19.7421 33.1664C18.127 34.2456 16.2281 34.8216 14.2856 34.8216C11.6817 34.8187 9.18519 33.7831 7.34393 31.9418C5.50267 30.1005 4.46701 27.6041 4.46417 25.0001ZM40.9945 44.5537C40.9941 44.814 40.8904 45.0636 40.7063 45.2477C40.5223 45.4318 40.2727 45.5354 40.0124 45.5359H17.1177C16.1301 45.534 15.1834 45.1407 14.4852 44.4421C13.787 43.7436 13.3942 42.7967 13.3927 41.8091V36.5626C13.6892 36.5841 13.9838 36.6073 14.2856 36.6073C14.6213 36.6073 14.9517 36.5841 15.2802 36.5573V40.8805C15.2812 41.6141 15.5732 42.3174 16.0921 42.836C16.611 43.3546 17.3145 43.6461 18.0481 43.6466H40.9945V44.5537ZM43.6856 41.8609H18.0481C17.7881 41.8604 17.5388 41.757 17.3548 41.5733C17.1707 41.3896 17.0669 41.1405 17.066 40.8805V36.2501C19.5849 35.6321 21.8237 34.187 23.4243 32.1462C25.025 30.1053 25.8948 27.5866 25.8948 24.993C25.8948 22.3994 25.025 19.8806 23.4243 17.8398C21.8237 15.799 19.5849 14.3539 17.066 13.7359V5.44657C17.0664 5.18623 17.1701 4.9367 17.3541 4.75261C17.5382 4.56853 17.7878 4.4649 18.0481 4.46443H36.5035V11.7341C36.5035 11.9709 36.5975 12.198 36.765 12.3654C36.9324 12.5329 37.1595 12.6269 37.3963 12.6269H44.6695V40.8805C44.6686 41.1408 44.5645 41.3902 44.3801 41.5739C44.1957 41.7577 43.9459 41.8609 43.6856 41.8609Z",
  fill: "url(#paint121_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.1194 28.7268C17.296 28.7267 17.4687 28.6743 17.6156 28.5761C17.7624 28.4779 17.8768 28.3383 17.9443 28.175C18.0118 28.0117 18.0293 27.8321 17.9947 27.6589C17.9601 27.4856 17.8748 27.3266 17.7497 27.2018L15.1783 24.6304V19.6429C15.1783 19.4061 15.0842 19.179 14.9168 19.0115C14.7493 18.8441 14.5222 18.75 14.2854 18.75C14.0486 18.75 13.8215 18.8441 13.6541 19.0115C13.4866 19.179 13.3926 19.4061 13.3926 19.6429V25C13.3924 25.1173 13.4153 25.2336 13.46 25.342C13.5048 25.4505 13.5704 25.5491 13.6533 25.6321L16.4872 28.4643C16.5701 28.5475 16.6687 28.6135 16.7771 28.6585C16.8856 28.7036 17.0019 28.7268 17.1194 28.7268Z",
  fill: "url(#paint122_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33.0358 10.7151C33.0358 10.4783 32.9417 10.2512 32.7743 10.0838C32.6068 9.91633 32.3797 9.82227 32.1429 9.82227H21.4286C21.1918 9.82227 20.9647 9.91633 20.7973 10.0838C20.6298 10.2512 20.5358 10.4783 20.5358 10.7151C20.5358 10.9519 20.6298 11.179 20.7973 11.3465C20.9647 11.5139 21.1918 11.608 21.4286 11.608H32.1429C32.3797 11.608 32.6068 11.5139 32.7743 11.3465C32.9417 11.179 33.0358 10.9519 33.0358 10.7151Z",
  fill: "url(#paint123_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.6785 16.0716C27.6785 16.3084 27.7725 16.5355 27.94 16.7029C28.1074 16.8704 28.3345 16.9644 28.5713 16.9644H33.9285C34.1653 16.9644 34.3924 16.8704 34.5598 16.7029C34.7273 16.5355 34.8213 16.3084 34.8213 16.0716C34.8213 15.8348 34.7273 15.6077 34.5598 15.4402C34.3924 15.2728 34.1653 15.1787 33.9285 15.1787H28.5713C28.3345 15.1787 28.1074 15.2728 27.94 15.4402C27.7725 15.6077 27.6785 15.8348 27.6785 16.0716Z",
  fill: "url(#paint124_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M39.2855 15.1787H37.4998C37.263 15.1787 37.0359 15.2728 36.8684 15.4402C36.701 15.6077 36.6069 15.8348 36.6069 16.0716C36.6069 16.3084 36.701 16.5355 36.8684 16.7029C37.0359 16.8704 37.263 16.9644 37.4998 16.9644H39.2855C39.5223 16.9644 39.7494 16.8704 39.9168 16.7029C40.0843 16.5355 40.1784 16.3084 40.1784 16.0716C40.1784 15.8348 40.0843 15.6077 39.9168 15.4402C39.7494 15.2728 39.5223 15.1787 39.2855 15.1787Z",
  fill: "url(#paint125_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M39.2856 20.5352H28.5713C28.3345 20.5352 28.1074 20.6292 27.94 20.7967C27.7725 20.9641 27.6785 21.1912 27.6785 21.428C27.6785 21.6648 27.7725 21.8919 27.94 22.0594C28.1074 22.2268 28.3345 22.3209 28.5713 22.3209H39.2856C39.5224 22.3209 39.7495 22.2268 39.917 22.0594C40.0844 21.8919 40.1785 21.6648 40.1785 21.428C40.1785 21.1912 40.0844 20.9641 39.917 20.7967C39.7495 20.6292 39.5224 20.5352 39.2856 20.5352Z",
  fill: "url(#paint126_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M39.2856 25.8936H28.5713C28.3345 25.8936 28.1074 25.9876 27.94 26.1551C27.7725 26.3225 27.6785 26.5496 27.6785 26.7864C27.6785 27.0232 27.7725 27.2503 27.94 27.4178C28.1074 27.5852 28.3345 27.6793 28.5713 27.6793H39.2856C39.5224 27.6793 39.7495 27.5852 39.917 27.4178C40.0844 27.2503 40.1785 27.0232 40.1785 26.7864C40.1785 26.5496 40.0844 26.3225 39.917 26.1551C39.7495 25.9876 39.5224 25.8936 39.2856 25.8936Z",
  fill: "url(#paint127_linear)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M39.2856 31.25H28.5713C28.3345 31.25 28.1074 31.3441 27.94 31.5115C27.7725 31.679 27.6785 31.9061 27.6785 32.1429C27.6785 32.3797 27.7725 32.6068 27.94 32.7742C28.1074 32.9416 28.3345 33.0357 28.5713 33.0357H39.2856C39.5224 33.0357 39.7495 32.9416 39.917 32.7742C40.0844 32.6068 40.1785 32.3797 40.1785 32.1429C40.1785 31.9061 40.0844 31.679 39.917 31.5115C39.7495 31.3441 39.5224 31.25 39.2856 31.25Z",
  fill: "url(#paint128_linear)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M39.2856 36.6074H28.5713C28.3345 36.6074 28.1074 36.7015 27.94 36.8689C27.7725 37.0364 27.6785 37.2635 27.6785 37.5003C27.6785 37.7371 27.7725 37.9642 27.94 38.1316C28.1074 38.2991 28.3345 38.3931 28.5713 38.3931H39.2856C39.5224 38.3931 39.7495 38.2991 39.917 38.1316C40.0844 37.9642 40.1785 37.7371 40.1785 37.5003C40.1785 37.2635 40.0844 37.0364 39.917 36.8689C39.7495 36.7015 39.5224 36.6074 39.2856 36.6074Z",
  fill: "url(#paint129_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint121_linear",
  x1: 0.97667,
  y1: 55.543,
  x2: 47.6802,
  y2: 4.69657,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint122_linear",
  x1: -4.41079,
  y1: 288.742,
  x2: 206.115,
  y2: 182.621,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint123_linear",
  x1: -30.9767,
  y1: 57.7098,
  x2: -18.8835,
  y2: -34.4516,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint124_linear",
  x1: 18.607,
  y1: 67.7412,
  x2: 39.0554,
  y2: -21.3079,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint125_linear",
  x1: 39.8176,
  y1: 71.3002,
  x2: 75.3733,
  y2: -6.11868,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint126_linear",
  x1: 40.6534,
  y1: 76.8834,
  x2: 52.7462,
  y2: -15.2746,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint127_linear",
  x1: 59.3409,
  y1: 84.6935,
  x2: 71.4337,
  y2: -7.46435,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint128_linear",
  x1: 78.016,
  y1: 92.5017,
  x2: 90.1092,
  y2: 0.340424,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint129_linear",
  x1: 96.7035,
  y1: 100.311,
  x2: 108.796,
  y2: 8.15271,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})));

function SvgInWorked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInWorked);
export default __webpack_public_path__ + "static/media/inWorked.a233192c.svg";
export { ForwardRef as ReactComponent };